export default "__VITE_ASSET__CfQyQuYD__"